import { create } from 'zustand';
import type { AuthStore } from '@lib/auth/types';
import { getHydratedAuthState, initializeAuthStore } from '@lib/auth/authListener';
import {
  signUp,
  signIn,
  completeMfaLogin,
  requestMfaCodeAgain,
  signOut,
  signInWithGoogle,
  resetPassword,
  resendVerificationEmail,
  fetchUserProfile,
  updateUser,
  checkSuspended
} from '@lib/auth/authActions';

export const useAuthStore = create<AuthStore>((set, get) => ({
  user: null,
  session: null,
  isAuthenticated: false,
  isLoading: true,
  error: null,
  isSuspended: false,
  pendingMfaEmail: null,
  ...getHydratedAuthState(),

  // Actions
  initialize: async () => {
    return initializeAuthStore(set, get);
  },

  signUp: async (data) => {
    return signUp(data, set, get);
  },

  signIn: async (data) => {
    return signIn(data, set, get);
  },

  completeMfaLogin: async (email, code) => {
    return completeMfaLogin(email, code, set, get);
  },

  requestMfaCodeAgain: async () => {
    return requestMfaCodeAgain(set);
  },

  clearPendingMfa: () => {
    import('@lib/auth/authCache').then(({ authCache }) => {
      authCache.pendingMfaAccessToken = null;
    }).catch(() => {});
    set({ pendingMfaEmail: null, error: null });
  },

  signOut: async () => {
    return signOut(set);
  },

  logout: async () => {
    return get().signOut();
  },

  signInWithGoogle: async () => {
    return signInWithGoogle(set);
  },

  resetPassword: async (email) => {
    return resetPassword(email, set);
  },

  resendVerificationEmail: async (email) => {
    return resendVerificationEmail(email, set);
  },

  fetchUserProfile: async () => {
    return fetchUserProfile(set, get);
  },

  updateUser: async (updates) => {
    return updateUser(updates, set, get);
  },

  updateUsername: async (newUsername) => {
    return get().updateUser({ username: newUsername });
  },

  checkSuspended: async () => {
    return checkSuspended(set, get);
  },

  clearError: () => {
    set({ error: null });
  },
}));
export default useAuthStore;
